/** Page-units of content visible across the viewport width when zooming to an object. */
export const ZOOM_TO_OBJECT_VISIBLE_AREA = 150;
